import FormField from "./FormField";

const TextAreaField = ({
  label,
  name,
  value,
  onChange,
  placeholder,
  required,
  description,
  rows = 4,
}) => (
  <FormField label={label} required={required} description={description}>
    <textarea
      name={name}
      value={value || ""}
      onChange={onChange}
      rows={rows}
      placeholder={placeholder}
      className="flex w-full rounded-sm border border-input bg-background px-3 py-2 text-sm ring-offset-background placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 border-gray-200 min-h-[80px]"
    />
  </FormField>
);

export default TextAreaField;
